import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IB2BQuotationInitialState, IB2BQuotation } from "./b2bQuotationModel";
import {
  findAllB2BQuotation,
  updateB2BPackageQuotation,
  deleteB2BPackageQuotation,
  findByB2BCustomQuotation,
  findB2BQuotationHistory,
} from "./services/b2bQuotation.services";

const initialState: IB2BQuotationInitialState = {
  loading: false,
  error: "",
  B2BQuotationList: [],
  B2BQuotationHistory: [],
  B2BQuotationID: null,
  B2BQuotationFilterDetails: {},
  B2BQuotationDetail: {
    QuotationId: null,
    QuotationReference: "AUTO-" + Math.random().toString(36).substr(2, 9).toUpperCase(),
    TripDestinationId: null,
    TripStartDate: "",
    TripEndDate: "",
    Adults: 2,
    Children: 0,
    Infants: 0,
    PackageOptions: [],
    TransportsAndActivities: {
      // SameCabTypeForAll: false,
      ServiceGroups: [],
      ExtraTransportationServices: [],
    },
    OtherSpecialServices: [],
    OtherSpecialServicesIsSameForAll: false,
    Inclusion: "",
    Exclusion: "",
    ImportantNotes: "",
    TermsConditions: "",
    Itinary: [],
  },
};

const b2bQuotationSlice = createSlice({
  name: "b2bQuotation",
  initialState,
  reducers: {
    setB2BQuotationDetail: (state, action: PayloadAction<Partial<IB2BQuotation>>) => {
      state.B2BQuotationDetail = { ...state.B2BQuotationDetail, ...action.payload };
    },
    clearB2BQuotationDetail: (state) => {
      state.B2BQuotationDetail = initialState.B2BQuotationDetail;
    },
    setB2BQuotationID: (state, action: PayloadAction<number | null>) => {
      state.B2BQuotationID = action.payload;
    },
    clearB2BQuotationID: (state) => {
      state.B2BQuotationID = null;
    },
    setB2BQuotationFilterDetails: (state, action: PayloadAction<any>) => {
      state.B2BQuotationFilterDetails = action.payload;
    },
    clearB2BQuotationFilterDetails: (state) => {
      state.B2BQuotationFilterDetails = {};
    },
  },
  extraReducers: (builder) => {
    builder
      // Find All
      .addCase(findAllB2BQuotation.pending, (state) => {
        state.loading = true;
      })
      .addCase(findAllB2BQuotation.fulfilled, (state, action) => {
        state.loading = false;
        state.B2BQuotationList = action.payload;
      })
      .addCase(findAllB2BQuotation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch B2B quotations";
      })
      // Find By ID
      .addCase(findByB2BCustomQuotation.pending, (state) => {
        state.loading = true;
      })
      .addCase(findByB2BCustomQuotation.fulfilled, (state, action) => {
        state.loading = false;
        state.B2BQuotationDetail = action.payload;
      })
      .addCase(findByB2BCustomQuotation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch B2B quotation details";
      })
      // Find History
      .addCase(findB2BQuotationHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(findB2BQuotationHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.B2BQuotationHistory = action.payload;
      })
      .addCase(findB2BQuotationHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch B2B quotation history";
      })
      // Update
      .addCase(updateB2BPackageQuotation.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateB2BPackageQuotation.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateB2BPackageQuotation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update B2B quotation";
      })
      // Delete
      .addCase(deleteB2BPackageQuotation.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteB2BPackageQuotation.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteB2BPackageQuotation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to delete B2B quotation";
      });
  },
});

export const {
  setB2BQuotationDetail,
  clearB2BQuotationDetail,
  setB2BQuotationID,
  clearB2BQuotationID,
  setB2BQuotationFilterDetails,
  clearB2BQuotationFilterDetails,
} = b2bQuotationSlice.actions;

export default b2bQuotationSlice.reducer;
